enum ROLE {
  ADMIN = "admin",
  OPERATOR = "operator",
  SELLER = "seller",
  BUYER = "buyer",
}

export default ROLE;
